// src/Camera.js
import React from 'react';
import {useLocation, useNavigate, Link} from 'react-router-dom';
import { BiSolidLeftArrow, BiX } from 'react-icons/bi';

import Camera from "../components/Camera";
import Header from '../components/Header';
import { sendAnalyticsData } from '../utilities/analytics';
const PageBasic = () => {
  sendAnalyticsData('View Page','Captured')
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <>
      <div className='header-bar-wrapper d-flex d-desktop-none'>
        <Header className='pb-0 align-items-center'/>
        <Link className='back page-back' style={{top: '35%'}} onClick={() => navigate(-1)}>
          <img className='icon-back' src='/images/icon-back.png' alt=''/>
        </Link>
      </div>
      <div className='full-height page-headerbar'>
        <div className='navigation d-none d-desktop-flex w-100 pt-2'>
          <Link className='back page-back' onClick={() => navigate(-1)}>
            <img className='icon-back' src='/images/icon-back.png' alt=''/>
          </Link>
        </div>
        <div className='camera-palette-wrapper d-flex flex-column justify-content-center' style={{height: 'calc(100vh - 48px - 5vh)'}}>
          <Camera/>
        </div>
        <Header className='d-none d-desktop-flex'/>
        {/* <img className='petal-result-bg' src='/images/petal-page-2.png' alt=''/> */}
      </div>
    </>
  );
};

export default PageBasic;
